// Copyright (c) 2018 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import {
    deleteFile,
    getFiles
} from '../../../product/shared/repositories';
import InformationRequestForm from '../state/information-request-form';
import actions from '../actions-list';

export const updateInfoRequestForm = partReturn =>

    dispatch => {

        dispatch({
            infoRequestForm: new InformationRequestForm({
                courierInfo: partReturn.courierInfo,
                files: partReturn.files,
                questions: partReturn.questions,
                returnStatus: partReturn.allowedReturnStatuses.findIndex(item => item.id === partReturn.returnStatus.id) > -1 ?
                    partReturn.returnStatus :
                    partReturn.allowedReturnStatuses[0]
            }),
            type: actions.UPDATE_REQUEST_DETAILS_INFO_REQUEST_FORM
        });

    };

export const updateInfoRequestFormAnswer = (answer, questionId, questions) => ({
    answer,
    questionId,
    questions,
    type: actions.UPDATE_REQUEST_DETAILS_INFO_REQUEST_FORM_ANSWER
});

export const updateInfoRequestFormReturnStatus = returnStatus => ({
    returnStatus,
    type: actions.UPDATE_REQUEST_DETAILS_INFO_REQUEST_FORM_RETURN_STATUS
});

export const updateInfoRequestFormComments = comments => ({
    comments,
    type: actions.UPDATE_REQUEST_DETAILS_INFO_REQUEST_FORM_COMMENTS
});

export const deleteInfoRequestFormFile = (fileToDelete, files) =>

    async dispatch => {

        const doesFileExist = files.some(item => item.fileName === fileToDelete.fileName && item.serialNumber === fileToDelete.serialNumber);

        if (doesFileExist) {

            dispatch(busyCounter.increaseBusyCounter());

            try {

                await deleteFile(fileToDelete);

                const filesArray = await getFiles(fileToDelete);

                dispatch({
                    files: filesArray,
                    type: actions.UPDATE_REQUEST_DETAILS_INFO_REQUEST_FORM_FILE
                });

            } catch (error) {

            } finally {

                dispatch(busyCounter.decreaseBusyCounter());

            }

        }

    };

export const addInfoRequestFormFile = file => ({
    file,
    type: actions.ADD_REQUEST_DETAILS_INFO_REQUEST_FORM_FILE
});



// WEBPACK FOOTER //
// ./src/part-requests/request-details/action-creators/information-request-form.js